import q2img from './Assets/Images/q2.png';
import q3img from './Assets/Images/q3.png';
import q4img from './Assets/Images/q4.png';

import { height, maxHeight, maxWidth } from '@mui/system';

export const questions_statistics = [
  {
    id: 1,
    title: <>Are you missing out on applying the <span style={{ color: "#CC972F", fontWeight: 500 }}>Gideon's Army Principle</span> to accelerate your&nbsp;fundraising?</>,
    desc: <>Please watch this video before answering the first&nbsp;question.</>,
    mediaPosition: "bottom",
    image: { 
      src: null, 
      desktop: { height: "auto", width: "calc(100% - 16px)" }, 
      mobile: { height: "auto", width: "calc(100% - 16px)", maxWidth: "97.5%" }
    },
    video: {
      src: "https://40parables-assets.s3.us-east-1.amazonaws.com/westfall-gold-q1-video.mp4",
      desktop: { height: "auto", width: "97.5%" },
      mobile: { height: "auto", maxHeight: "250px", width: "97.5%", maxWidth: "97.5%" }
    }
  },
  {
    id: 2,
    title: <>Many pastors feel intimidated approaching high-capacity&nbsp;givers...</>,
    desc: <>...but in reality, those givers are actually <span style={{ color: "#CC972F", fontWeight: 500 }}>more comfortable talking about money</span> than you think they&nbsp;are.</>,
    mediaPosition: "top",
    image: {
      src: q2img,
      desktop: { height: "300px", width: "auto" }, 
      mobile: { height: "auto", maxHeight: "320px", width: "100%", maxWidth: "100%" }
    }
  },
  {
    id: 3,
    title: <>Did you know?</>,
    desc: <>People engaged in volunteering activities <span style={{ color: "#CC972F", fontWeight: 500 }}>give 50% more</span> to their&nbsp;church.<br/><br/>However, <span style={{ color: "#CC972F", fontWeight: 500 }}>few church leaders view volunteering</span> as part of their giving&nbsp;strategy.</>,
    mediaPosition: "top",
    image: {
      src: q3img, 
      desktop: { height: "auto", width: "75%", maxWidth: "280px" }, 
      mobile: { height: "auto", width: "75%" }
    }
  },
  {
    id: 4,
    title: <>A common error that pastors make...</>,
    desc: <>...is combining communication to high-level volunteers and high-capacity givers. But often <span style={{ color: "#CC972F", fontWeight: 500 }}>these groups don't always relate or benefit from the same&nbsp;messaging.</span><br/><br/>The goal is to <span style={{ color: "#CC972F", fontWeight: 500 }}>develop relationship</span>. You have an opportunity to <span style={{ color: "#CC972F", fontWeight: 500 }}>communicate differently</span> with high-capacity&nbsp;givers.</>,
    mediaPosition: "bottom",
    image: {
      src: q4img, 
      desktop: { height: "300px", width: "auto" }, 
      mobile: { height: "auto", maxHeight: "320px", width: "100%", maxWidth: "100%" }
    }
  }
];
